import { render, staticRenderFns } from "./Step4ProductsFilter.vue?vue&type=template&id=63803dda&scoped=true"
import script from "./Step4ProductsFilter.vue?vue&type=script&lang=js"
export * from "./Step4ProductsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63803dda",
  null
  
)

export default component.exports